import React from "react";
import {Edit as EditIcon, Delete as DeleteIcon,} from "@mui/icons-material";import { useEffect, useState } from "react";
import axios from "axios";
import {Box,Button,Card,CardContent,CardHeader,Grid,IconButton,TextField,Tooltip,Typography,} from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import {catalogoSave, catalogoDelete, catalogoUpdate} from "../../../services/CatalogoServices";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import MUIXDataGrid from "../../Ayuda/MUIXDataGrid";

export interface TipoProcesoInterface {
  uuid: string;
  Cve: string;
  Nombre: string;
  Descripcion: string;
  creadopor:          string;
  modificadopor:      string;
  eliminadopor:       string;     
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 5,
  p: 2,
};

export default function   TipoProceso() {
  const TITULO = "Catálogo de Tipo Proceso";
  const TITULODETALLE = "Detalle de Tipo Proceso";
  document.title = TITULO;

  const navigate                          = useNavigate();
  const [uuid, setuuid]                   = useState("");
  const [cve, setCve]                     = useState("");
  const [nombre, setNombre]               = useState("");
  const [descripcion, setDescripcion]     = useState("");
  const [creadopor, setCreadoPor]         = useState("");
  const [modificadopor, setModificadoPor] = useState("");
  const [eliminadopor, setEliminadoPor]   = useState("");
  const [forceUpdateKey, setForceUpdateKey] = useState(0);
  // Abrir modal
  const [open, setOpen]               = React.useState(false);
  const handleOpen = ()   => setOpen(true);
  const handleClose = ()  => setOpen(false);

  const handleSave = () => {
    if (cve === "" || nombre === "" || descripcion === ""){
      Swal.fire({
        icon  : "error",
        title : "¡Error!",
        text  : "Favor de completar los campos",
        confirmButtonColor: "#15212f",
      });
    } else {
      //aqui se arma el body que se va a enviar al endpoint los campos se deben llamar exactamente igual a como se envian al endpoint en insomia (minusculas)
      const data = {
        Cve                   : cve,
        Nombre                : nombre,
        Descripcion           : descripcion,
        Creadopor             : localStorage.getItem("IdUsuario"),
        Eliminadopor          : eliminadopor,
      };
      const url = "/catalogo/pvAreaFisica";
      catalogoSave(data,url).then((response) =>{
        setOpen(false);
        getAllTipoProceso();
      })
    }
  };
  const handleDelete = (event: any, cellValues: any) => {
    const data = cellValues.row.uuid;
    const descripcion = cellValues.row.Descripcion;   
    const url = "/catalogo/pvAreaFisica";
    catalogoDelete(data,url,descripcion).then((response) =>{
      setOpen(false);
      getAllTipoProceso();
    })
  };
  const handleUpdate = () => {
    if (cve === "" || nombre === "" || descripcion === ""){
      Swal.fire({
        icon  : "error",
        title : "¡Error!",
        text  : "Favor de completar los campos",
        confirmButtonColor: "#15212f",
      });
    } else {
      //aqui se arma el body que se va a enviar al endpoint los campos se deben llamar exactamente igual a como se envian al endpoint en insomia (minusculas)
      const data = {
        uuid                  : uuid,
        Cve                   : cve,
        Nombre                : nombre,
        Descripcion           : descripcion,
        Creadopor             : creadopor,
        Modificadopor         : localStorage.getItem("IdUsuario"),
        Eliminadopor          : eliminadopor,
      };
      const url = "/catalogo/pvAreaFisica";
      catalogoUpdate(data,url).then((response) =>{
        setOpen(false);
        getAllTipoProceso();
      })
    }
  }; 

  const columns = [
    {
      field: "acciones",
      headerName: "Acciones",
      width: 80,
      headerAlign: "left",
      hideable: false,
      renderCell: (cellValues: any) => {
        return (
          <Box>
           <Tooltip title={"Editar"}>
           <IconButton color="inherit"
              // al darle editar se llenan los campos con los valores seleccionados del renglon
              onClick={(event) => {     
                setuuid(cellValues.row.uuid);
                setCve(cellValues.row.Cve);
                setNombre(cellValues.row.Nombre);
                setDescripcion(cellValues.row.Descripcion);
                setCreadoPor(cellValues.row.CreadoPor);   
                setModificadoPor(cellValues.row.ModificadoPor);
                setEliminadoPor(cellValues.row.EliminadoPor);
                handleOpen();
              }}
           >
                <EditIcon />
              </IconButton>
           </Tooltip>
           <Tooltip title={"Eliminar"}>
              <IconButton color="inherit"
                onClick={(event) => {handleDelete(event, cellValues);}}
               >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
     {
      field: "Cve",
      headerName: "Clave",
      width: 100,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "Nombre",
      headerName: "Nombre",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "Descripcion",
      headerName: "Descripción",
      width: 650,
      hideable: false,
      headerAlign: "left",
    },
  ];
  const camposCsv = ["Cve","Nombre","Descripcion"];
  const [rows, setRows] = useState([]);
  const getAllTipoProceso= () => {
    const timestamp = new Date().getTime(); // Generar un timestamp único
    axios({
      method    : "get",

      url: `${process.env.REACT_APP_APPLICATION_ENDPOINT}/catalogo/pvAreaFisica?timestamp=${timestamp}`,
      headers   : {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("jwtToken") || "",
      },
    })
      // aqui se recibe lo del endpoint en response
      .then(({data}) => {
        if (data) {
          setRows(data.data);
        } else {
          setRows([])
        }
        setForceUpdateKey((prev) => prev + 1); // Fuerza el re-renderizado
      })
      .catch(function (error) {
        Swal.fire({
          icon  : "error",
          title : "¡Error!",
          text  : "("+error.response.status+") "+error.response.data.message,
        }).then((r) => navigate("/admin/catalogos/proceso"));
      });
  };

 useEffect(() => {
    if(!open)
        getAllTipoProceso();
  }, [open]);


  // esto es para que se ejecuten todo los get de los listados solo cuando se abra la modal,y que limpie las variables cuando se salga de la modal
   useEffect(() => {
     // Limpieza de campos al cerrar la modal
     if (!open) {
       setuuid("");
       setCve("");
       setNombre("");
       setDescripcion("");
       setCreadoPor("");
       setModificadoPor("");
       setEliminadoPor("");
     }
   }, [open]);
 
  return (
    // contenedor principal
    <Grid container sx={{ }}>
      <BreadcrumbBar 
          links={[{texto:'Inicio', link:'/admin'},
                  // {texto:'Configuración', link:'#'},
                  {texto:'Catálogos', link:'/admin/catalogos'}]
                } 
                  Titulo={TITULO}
      />
      {/* la verdad este grid aun no entiendo que es o que funcion tiene */}
      <Grid container xs={12} justifyContent={"center"}>
        <Grid item xs={12} md={12} mt={2}>
          <Card sx={{ p: 0, boxShadow: 8 }}>
          <CardHeader sx={{ position: "absolute", fontFamily: "MontserratSemiBold"}} />
            <Typography  variant="h5" sx={{ paddingTop:"1%", paddingLeft:"1%" }}>  {TITULO} </Typography>                
            <CardContent sx={{ fontFamily: "MontserratBold", bgcolor: "" }}>
              {/* aqui es el cardcontent que es el contenido del card,y ponemos primero un box y estamos dibujando el boton para agregar un nuevo registro */}
              <Box display="flex" justifyContent="flex-end">
                <Grid
                  sx={{
                    display       : "flex",
                    alignItems    : "right",
                    justifyContent: "right",
                    paddingBottom : "2%",
                    paddingRight  : "1%",
                  }}
                >
                  <Button
                    onClick={handleOpen}
                    variant="contained"
                    sx={{ margin: "1%", color: "#FFFFFF" }}
                  >
                    <Typography
                      sx={{
                        color     : "#FFFFFF","&:hover": { color: "#15212f" },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize  : "100%",
                      }}
                    >
                      Agregar
                    </Typography>
                  </Button>
                  <Button 
                    onClick={() => navigate(-1)}
                    color="secondary"
                    sx={{margin:"1%"}}
                    variant="contained">
                    <Typography
                    sx={{color: "#ffffff",
                    "&:hover":{
                      color:"#15212f",
                      },
                    fontFamily: "MontserratRegular, sans-serif",
                    fontSize: "100%",}}>
                    Cancelar
                    </Typography>
                    </Button>                  
                </Grid>
              </Box>
              {/* aqui se asigna un id unico que tiene que tener cada renglon, asi que asignamos un numero al azar*/}
              <MUIXDataGrid id={Math.random} columns={columns} rows={rows} camposCsv={camposCsv}/>
              {/* AGREGAR---------------------------------------------------------------------------------------------------------------------------------------------- */}
              {/* Inician los campos del formulario*/}
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} display="flow">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="h5" sx={{ padding: "1%" }}>
                          {TITULODETALLE}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{"& > :not(style)": { m: 1.3, width: "100%" },}}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          label     ="Clave"
                          size      ="small"
                          variant   ="outlined"
                          value     ={cve}
                          disabled  = {uuid!=="" ? true:false}
                          onChange  ={(v) => {setCve(v.target.value); }}
                          inputProps={{ maxLength: 10 }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box>
                        {/* espacio en blanco */}
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{"& > :not(style)": { m: 1.3, width: "100%" },}}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label     ="Nombre"
                          size      ="small"
                          variant   ="outlined"
                          value     ={nombre}
                          onChange  ={(v) => {setNombre(v.target.value); }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{"& > :not(style)": { m: 1.3, width: "100%" },}}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label     ="Descripción"
                          size      ="small"
                          variant   ="outlined"
                          value     ={descripcion}
                          onChange  ={(v) => {setDescripcion(v.target.value); }}
                        />
                      </Box>
                    </Grid>                    
                    <Grid item xs={12}>
                      <Box
                        maxWidth      ="100%"
                        paddingTop    ={2}
                        paddingBottom ={2}
                        display       ="flex"
                        justifyContent="end"
                      >
                        <Button
                          onClick={() => {
                            if (uuid === "") {
                              handleSave()  
                            }else{
                              handleUpdate()  
                            }
                            } 
                          }
                          variant ="contained"
                          sx      ={{margin: "1%", color: "white","&:hover": {color: "#15212f",},}}
                        >
                          Guardar
                        </Button>
                        <Button
                          onClick ={handleClose}
                          variant ="contained"
                          color   ="secondary"
                          sx      ={{margin: "1%",color: "white","&:hover": {color: "#15212f",},}}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
              {/* Termina la sección de los campos del formulario*/}
              {/* AGREGAR----------------------------------------------------------------------------------------------------------*/}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}